import type { StatusColors } from '@nexelem/components';
import { TaskStatus, type TaskToDoEntry } from '@nexelem/graphne-api';

const taskStatusColor = new Map<TaskStatus, StatusColors>([
  [TaskStatus.Completed, 'green'],
  [TaskStatus.Error, 'red'],
  [TaskStatus.InProgress, 'blue'],
  [TaskStatus.NotPlanned, 'grey'],
  [TaskStatus.Pending, 'yellow'],
]);

export const getTaskStatusColor = (color?: TaskStatus) => (color ? taskStatusColor.get(color) : 'grey');

export const getCheckableStatus = (taskStatus?: TaskStatus, notPlannedDependencies?: number[]) =>
  !!notPlannedDependencies?.length || taskStatus === TaskStatus.NotPlanned;

export type FlatListGroup =
  | { kind: 'task'; task: TaskToDoEntry }
  | { kind: 'batch'; batchId: number; tasks: TaskToDoEntry[] };

export const groupTasksByBatch = (tasks: TaskToDoEntry[]): FlatListGroup[] => {
  const groups: FlatListGroup[] = [];
  const batchGroupIndex = new Map<number, number>();

  tasks.forEach((task) => {
    if (task.batchId == null) {
      groups.push({ kind: 'task', task });
      return;
    }

    const existingIndex = batchGroupIndex.get(task.batchId);
    if (existingIndex === undefined) {
      batchGroupIndex.set(task.batchId, groups.length);
      groups.push({ kind: 'batch', batchId: task.batchId, tasks: [task] });
      return;
    }

    const group = groups[existingIndex];
    if (group.kind === 'batch') {
      group.tasks.push(task);
    }
  });

  return groups;
};
